import React, { Fragment } from "react";
import { Formik } from "formik";
import Content from "components/QRCodeEditor/Content";
import { getManualContactlessConfigInitialValues } from "utils/contactless";
import { SPLIT_CONTENT_MAX_WIDTH } from "utils/constants/ui";
import ConnectedTextarea from "components/ConnectedTextarea";
import { LAZY_URL_REQUIRED_SCHEMA } from "constants/validation";

const QRCodeManualEditor = ({
  validate,
  url,
  withRedirect = false,
  formChildren,
  qrCode
}) => {
  const initialValues = getManualContactlessConfigInitialValues({
    url,
    withRedirect,
    qrCode
  });

  const formProps = {
    initialValues
  };
  if (validate) {
    formProps.validate = validate;
  } else {
    formProps.validationSchema = LAZY_URL_REQUIRED_SCHEMA;
  }

  return (
    <Formik {...formProps}>
      {() => (
        <Fragment>
          <div
            className="w-100 flex flex-column center"
            style={{ maxWidth: SPLIT_CONTENT_MAX_WIDTH }}
          >
            <div className="flex flex-column pb3 center w-100 z-1 ph3">
              <div className="field__label fw5 db">URL</div>
              <ConnectedTextarea
                name="url"
                placeholder="Enter a url"
                minRows={1}
              />
            </div>
          </div>
          <div className="w-100 relative bt bb hairline-1">
            <div className="dn dn-m flex-ns flex-row absolute top-0 left-0 right-0 bottom-0 overflow-hidden">
              <div className="w-50 bg-off-white-ns"></div>
              <div className="w-50 split__container-ns bg-white"></div>
            </div>
            <div className="pv4">
              <Content manual>{formChildren}</Content>
            </div>
          </div>
        </Fragment>
      )}
    </Formik>
  );
};

export default QRCodeManualEditor;
